/**
 * Read from `mermaid`'s own package.json (a few bytes) rather than the
 * dynamically-imported renderer, so the status bar can show the pinned
 * version immediately without waiting on the ~1MB chunk (CLAUDE.md rule 5).
 */
import { version } from 'mermaid/package.json';

export const MERMAID_VERSION = version;
